import React, { Component} from 'react';
import cookie from 'react-cookies'
import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom';
import { Helmet } from "react-helmet";
import i18next from 'i18next';
import { Pages } from './common/config/LinkRoutes';
import templateServices from './services/TemplateServices';
import { observer, inject } from 'mobx-react';
import AccountAction from './actions/AccountAction';
import Utils from './common/Utils';
import { EVENT } from './common/events/listEvents';
import Constants from './common/Constants';
import './../styles/css/WaitLoading.css'; 
import { OddsFormat, MOBILE_VIEWS, MARKET_STRATEGIES, PrefsMap } from './common/Foundation';
import { isIOS } from 'react-device-detect';
import _ from 'lodash';
import AlertComponentAction from './components/BaseComponent/AlertComponent/AlertComponentAction';
import CommonActions from './actions/CommonActions';
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import MemberServices from './services/MemberService';

import MbDynamicBody from './pages/MbDynamicBody';
import MbLayoutPage from './pages/MbLayoutPage';

@inject('LayoutTemplateStore', 'AccountStore', 'SportsStore')
@observer
export default class Routes extends Component {
	constructor(props) {
		const APP_ROUTER_BASE = '/m';
		window.APP_ROUTER_BASE = APP_ROUTER_BASE;
		super(props)
		this.updateViewAction();
		this.getDataNoCache = this.getDataNoCache.bind(this);
		this.modeDev = !process.env.NODE_ENV || process.env.NODE_ENV === 'development';
		// let modeDev = true;
		//hardcode: skin ps3838 for dev
		this.templateName = 'pa';//'pa'//b38//b42//b50//darkblue3//ipaes//ipasp//mmx//p88//pa//ps3838//psp//skin4//skin5//skin6//skin8;
		const allParams = Utils.getAllUrlParams(window.location.href);
		if (allParams.templatename != null && allParams.templatename.length > 0) {
			this.templateName = allParams.templatename;
		}
		/** trick for by pass server vanish caching */
		this.versionBuild = window.versionBuild;
		const scripts = document.getElementsByTagName('script');
		for (let i = 0;i < scripts.length;i++) {
			const lastScript = scripts[i];
			lastScript.async = true;
			const scriptName = lastScript.src;
			if (scriptName.includes("static/js/main") || scriptName.includes("static/js/bundle")) {
				this.versionBuild = scriptName.split("/").pop();
			}
		}
	}

	componentDidMount() {
		AccountAction.checkLogout().then(this.initGlobalData.bind(this));

		window.onbeforeunload = function () {
			window.scrollTo(0, 0);
		}
		
		
		//call account balance to update store
		this.intervalTime = setInterval(this.reloadAccountBalance, 10 * 1000)
		window.listenEvent(EVENT.GET_DATA_NOCACHE, this.getDataNoCache);
		window.listenEvent(EVENT.ACCOUNT_BALANCE_RELOAD, this.reloadAccountBalance);
		window.listenEvent(EVENT.OPEN_LOGIN, this.requiredFormLogin);		
	}

	componentWillUnmount() {
		window.stopListenEvent(EVENT.GET_DATA_NOCACHE, this.getDataNoCache);
		window.stopListenEvent(EVENT.OPEN_LOGIN, this.requiredFormLogin);	
		window.stopListenEvent(EVENT.ACCOUNT_BALANCE_RELOAD, this.reloadAccountBalance);
		if (this.intervalTime) {
			clearInterval(this.intervalTime)
		}
	}

	/**
	 * Get data nocache
	 */
	getDataNoCache() {
		AccountAction.getDataNoCache(this.templateName, this.props.LayoutTemplateStore).then(user => {
			this.props.AccountStore.updateUser(user);
			this.props.LayoutTemplateStore.updateIsAllowCheckValidPage(true);
			if (user.auth) {
				AccountAction.getQuickStakeData(this.props.AccountStore);
				this.updateCookies();
				window.fireEvent(EVENT.ACCOUNT_BALANCE_RELOAD);
				AccountAction.openNewBetslipMobileNotify();
			} else {
				this.reloadAccountBalance();
			}

			// Make sure Sport Store options is synchronous with Data No Cache
			const __udata = localStorage.getItem('__udata') ? JSON.parse(window.atob(localStorage.getItem('__udata'))) : null
			if (__udata) {
				this.updateSportStoreOptions(__udata)
			}
			const __prefs = _.isEmpty(cookie.load('__prefs')) ? '' : Utils.decodeBase64(cookie.load('__prefs'));
			const __prefsJSON = _.isEmpty(__prefs) ? {} : Utils.convertStringToJSON(__prefs);
			const sportsSorting = !_.isEmpty(__prefsJSON) && [",", __prefsJSON[PrefsMap.sportsSorting], ","].join("") || "";
			this.props.SportsStore.updateOptions({ sportsSorting });
		});
	}

	async initGlobalData() {
		const promise = this.modeDev
			? templateServices.loadTemplateDataFromLocal(this.templateName)
			: templateServices.loadTemplateData();
			
		const res = await promise;
		if (res) {
			this.props.LayoutTemplateStore.updateTemplateData(res);
			this.actionWithBrowser();
			this.getDataNoCache()
		}
	}

	updateSportStoreOptions = (__udata) => {
		const { oddsFormat } = this.props.SportsStore.options
		const oddsSetting = __udata.oddsFormatSetting.split(',')
		const matchedOddsFormat = oddsSetting.filter(of => OddsFormat[of] === oddsFormat)
		let defaultOddsFormat = matchedOddsFormat.length > 0 ? oddsFormat : OddsFormat[oddsSetting[0]]
		/**
		 *  Max Bet Reference BASE
		 * 
		 * */
		if (__udata.maxBetPreferenceSettingBase) {
			defaultOddsFormat = OddsFormat.AM;
		}
		const updatedOptions = {
			oddsFormat: defaultOddsFormat,
			oddsFormatSetting: __udata.oddsFormatSetting,
		}
		this.props.SportsStore.updateOptions(updatedOptions)
	}

	reloadAccountBalance = () => {
    const auth = AccountAction.isAuth();
		if (auth) {
			AccountAction.reloadAccountBalance(this.props.AccountStore);
			if (this.props.AccountStore.isAuth) {
				// Update Player type
				const {type} = this.props.AccountStore.user
				if (type) {
					document.body.classList.add(type);
					document.documentElement.classList.add(type);
				}

				if (this.props.LayoutTemplateStore.currentPageContainer !== 'termsConditionsPageContainer') {
					let activeFirstLogin = false;
					const isShowAcceptTC = cookie.load('isShowAcceptTC');
					if (isShowAcceptTC) {
							activeFirstLogin = JSON.parse(isShowAcceptTC);
					}
					if (activeFirstLogin) {
						window.fireEvent(EVENT.FIRST_LOGIN);
					}
				}
			} 
		} else {
			this.props.AccountStore.updateUser({
				auth: false,
				token: "",
				loginId: "",
				freshId: "",
				email: "",
				fullName: "",
				mode: "",
				type: "",
				betCredit: "",
				outstanding: "",
				currency: "",
				message: "",
				isRefresh: false,
				locale: cookie.load('locale') || 'en_US',
				skin: cookie.load('skin') || 'pa',
				openMessage: false,
				'defaultView': ''
			});
		}
  }
  
  /**
   * if user switches from desktop to mobile on the same browser, then we will add 'session' cookies and remove
   * few cookies which was added on desktop site.
   */
  updateCookies = () => {
    const sessionCookies = cookie.load('session');
    if (!sessionCookies) {
      AccountAction.initSessionCookies();
    }
  }

	actionWithBrowser() {
    this.updateWaitLoading();
    this.injectTrackingScripts();
    this.initFingerPrintId();
	const paramAfCode = Utils.getParameterByName("a") || '';
		
		const afrcCode = cookie.load('afrc');

			if (!afrcCode) {
				Utils.saveCookie('afrc', paramAfCode, {
					path: "/",
					domain: AccountAction.getSubDomain(),
					expires: window.env.afrcExpriseTime
				});
			}
			

		//Use in case redirect from desktop on IOS device
		const afrcStorage = localStorage.getItem("afrc")
		if (afrcStorage && window.env.marketStrategies === MARKET_STRATEGIES.CASH) { //!paramAfCode confirmed dev to remove this variable, due to it was commented above
			if (!afrcCode) {
				Utils.saveCookie('afrc', afrcStorage, {
					path: "/",
					domain: AccountAction.getSubDomain(),
					expires: window.env.afrcExpriseTime
				});
			}
			this.props.AccountStore.updateAffiliateCode(afrcStorage);
			localStorage.removeItem("afrc");
		}
		const {currentViewContainer} = this.props.LayoutTemplateStore;
		if (currentViewContainer === MOBILE_VIEWS.EURO) {
			const head = document.head;
			const slickUrl = "https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css";
			const slickThemeUrl = "https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css";
			const slickLink = CommonActions.getExternalCssLink(slickUrl);
			const slickThemeLink = CommonActions.getExternalCssLink(slickThemeUrl);
			head.appendChild(slickLink);
			head.appendChild(slickThemeLink); 
		}
	}


  injectTrackingScripts = () => {
    if (window.env.hotJarId) {
      const hotJar = document.createElement("script");
      hotJar.innerHTML = `
      (function(h,o,t,j,a,r){
        h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
        h._hjSettings={hjid:${window.env.hotJarId},hjsv:6};
        a=o.getElementsByTagName('head')[0];
        r=o.createElement('script');r.async=1;
        r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
        a.appendChild(r);
      })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');`;
      document.head.appendChild(hotJar);
    }

		if (window.env.botManagementKey) {
			const botManagement = document.createElement("script");
			botManagement.innerHTML = `!(function(a,b,c,d,e,f,g){
				a.sikey=e;a.fpendpoint=f;a.siendpoint=g;
				var m=b.createElement(c),n=b.getElementsByTagName(c)[0];
				m.async=1,m.src=d,n.parentNode.insertBefore(m, n);})
				(window,document,"script","https://app.intellifend.com/agentjs/latest/tags-fast.js",
				["${window.env.botManagementKey}","", []],"https://tls-fp.intellifend.com/","https://app.intellifend.com");`;
			document.head.appendChild(botManagement);
		}
  }
  
  initFingerPrintId = async () => {
    const fp = await FingerprintJS.load();
    const result = await fp.get();
    const currentId = cookie.load('_vid');
    const visitorId = result.visitorId;
    if (!currentId || currentId !== visitorId) {
      Utils.saveCookie('_vid', visitorId, {expires: 60, path: "/", domain: AccountAction.getSubDomain()});
      MemberServices.updateFingerPrintId({"fpId": visitorId});
    }
  }

	updateWaitLoading = () => {
		this.props.LayoutTemplateStore.updateIsWait(false);
	}

	getPageTitle() {
		if (this.props.LayoutTemplateStore.templateData.attributes.isB2B) {
			return this.props.LayoutTemplateStore.templateData.attributes.metaTitle;
		}
		const originalKey = this.props.LayoutTemplateStore.templateData.attributes.skinName + ".pageTitle";
		const defaultPageTitle = i18next.t("pa.pageTitle");
		return i18next.t(originalKey, defaultPageTitle);
	}

	updateViewAction = () => {
		const viewContainer = templateServices.getViewByURLPath();
		this.props.LayoutTemplateStore.updateCurrentViewContainer(viewContainer);
		document.body.classList.add(viewContainer);
		document.documentElement.classList.add(viewContainer);
	}

	render() {
		const {templateData}  = this.props.LayoutTemplateStore;
		const cssFonts = `${process.env.PUBLIC_URL}${this.props.LayoutTemplateStore.templateData.cssFontFile ?
			`/${this.props.LayoutTemplateStore.templateData.cssFontFile}?v=${this.versionBuild}` :
			`/estharmb/fonts/Fonts.css?v=${this.versionBuild}`}`;
		return this.props.LayoutTemplateStore.isWait ? CommonActions.renderWaitLoading(null) : (
			<BrowserRouter basename={window.APP_ROUTER_BASE}>
				<div id="wrapper">
					<Helmet>
						<meta charSet="utf-8" />
						<meta property="og:type" content={templateData.attributes.metaType} />
						<link rel="shortcut icon" href={process.env.PUBLIC_URL + '/estharmb/images/' + templateData.attributes.skinName + "/favicon.ico"}></link>
						<link rel="apple-touch-icon" href={process.env.PUBLIC_URL + '/estharmb/images/' + templateData.attributes.skinName + "/ios/57x57.png"}></link>
						<link rel="apple-touch-icon" sizes="72x72" href={process.env.PUBLIC_URL + '/estharmb/images/' + templateData.attributes.skinName + "/ios/72x72.png"}></link>
						<link rel="apple-touch-icon" sizes="114x114" href={process.env.PUBLIC_URL + '/estharmb/images/' + templateData.attributes.skinName + "/ios/114x114.png"}></link>
						<link rel="apple-touch-icon" sizes="144x144" href={process.env.PUBLIC_URL + '/estharmb/images/' + templateData.attributes.skinName + "/ios/144x144.png"}></link>
						<link id="font-stylesheet" rel="preload stylesheet" href={cssFonts} as="style" type="text/css" crossorigin></link>
						<link id="skin-stylesheet" rel="preload stylesheet" href={this.renderCssFile()} as="style" type="text/css" crossorigin></link>
						<link rel="preload" href="/estharmb/fonts/roboto/font/Roboto-Medium.ttf" as="font" type="font/ttf" crossorigin></link>
						{ !isIOS ? <link rel="manifest" href={process.env.PUBLIC_URL + "/m/manifest.json" }/> : null }
						<title>{this.getPageTitle()}</title>					
						
					</Helmet>
					<Switch>
						{/* <Route exact path={"/:lang"  +"/register"} component={Pages.mobileRegister} /> */}
						<Route path={"/:lang"} render={(props) => this.renderRoute(props)} />
						<Redirect from="/" to={`/${Utils.getCurrentLang()}/`} />
					</Switch>
					
					
				</div>	
			</BrowserRouter>

		)
	}
	renderCssFile = () => {
		const {currentViewContainer, templateData}  = this.props.LayoutTemplateStore;
		const cssFile = templateData.cssFile || {};
		const cssLink = currentViewContainer !== MOBILE_VIEWS.ASIA ? cssFile.euro : cssFile.asian;
		return `${(!cssLink || cssLink.startsWith("http") || cssLink.startsWith("https")) ? cssLink : process.env.PUBLIC_URL}
		/${cssLink}?v=${this.versionBuild}`;
	}

	renderRoute = (props) =>{
		//nin.os: use this regEx to make sure the url contains lang patern like: en, fr or zh-cn,
		const regEx = '([a-z]{2}|[a-z]{2}-[a-z]{2})';
		// In template layout at B2B skin homePageContainer do not call any component 
		// Let OddsPagecontianer become default component for B2B
		const homePageContainer = this.props.LayoutTemplateStore.templateData.attributes.isB2B
		? 'oddsPageContainer' : 'homePageContainer';
 		return(
			<React.Fragment>
			<Switch>
				{/* //nin.os: Page no MbLayout*/}
				<Route exact path={"/:lang" + regEx +"/asian/register"} component={Pages.mobileRegister} />
				<Route exact path={"/:lang" + regEx +"/asian/register/?a=:afCode"} component={Pages.mobileRegister} />
				<Route exact path={"/:lang" + regEx +"/asian/forgot-password"} component={Pages.mobileForgotPassword} />
				<Route exact path={"/:lang" + regEx +"/asian/forgot-email"} component={Pages.mobileForgotEmail} />
				<Route exact path={"/:lang" + regEx+"/asian/contact-us"} component={Pages.mobileAsiaContactUs}/>
				<Route exact path={"/:lang" + regEx+"/asian/qr-code"} component={Pages.mobileAsiaQRCode}/>
				<Route exact path={"/:lang" + regEx+"/asian/vs/not-supported"} component={Pages.mobileNotSupported}/>
				<Route exact path={"/:lang" + regEx+"/asian/activeLink"} component={Pages.mobileActiveLink} />

				<MbLayoutPage {...props}>
					<Switch>
						<Route exact path={"/:lang" + regEx +"/demo"} component={Pages.mobiledemo} />					
						<Route exact path={"/:lang" + regEx+"/"} render={(props) => this.renderPage(props,'homePageContainer')}/>
						<Route exact path={"/:lang" + regEx+"/login"} render={(props) => this.renderPage(props,'loginPageContainer')}/>	
						<Route exact path={"/:lang" + regEx+"/logout"} render={(props) => this.renderLogout()}/>
						<Route exact path={"/:lang" + regEx+"/terms-conditions"} render={(props) => this.renderPage(props,'termsConditionsPageContainerInfo')}/>
						<Route exact path={"/:lang" + regEx+"/betting-rules"} render={(props) => this.renderPage(props,'bettingRulesPageContainerInfo')}/>
						<Route exact path={"/:lang" + regEx+"/balance"} render={(props) => this.renderPage(props,'balancePageContainer')}/>	
						<Route exact path={"/:lang" + regEx+"/settings"} render={(props) => this.renderPage(props,'settingPageContainer')}/>	
						<Route exact path={"/:lang" + regEx+"/tc-page"} render={(props) => this.renderPage(props,'termsConditionsPageContainer')}/>			
						<Route exact path={"/:lang" + regEx+"/pending-bets"} render={(props) => this.renderPage(props,'pendingBetPageContainer')}/>	
						<Route exact path={"/:lang" + regEx+"/bets-offered"} render={(props) => this.renderPage(props,'betsOfferedPageContainerInfo')}/>
						<Route exact path={"/:lang" + regEx+"/change-password"} render={(props) => this.renderPage(props,'changePasswordContainer')}/>

						{/* defined for asian */}
		
						<Route exact path={"/:lang" + regEx + "/asian"} render={(props) => this.renderPage(props, homePageContainer)} />
						<Route exact path={"/:lang" + regEx+"/asian/profile"} render={(props) => this.renderPage(props,'profilePageContainer')}/>
						<Route exact path={"/:lang" + regEx+"/asian/account"} render={(props) => this.renderPage(props,'ngcPageContainer')}/>
						<Route exact path={"/:lang" + regEx+"/asian/account/:ngcPage"} render={(props) => this.renderPage(props,'ngcPageContainer')}/>
						<Route exact path={"/:lang" + regEx+"/asian/account/:ngcPage/:paymentChanelCode"} render={(props) => this.renderPage(props,'ngcPageContainer')}/>
						<Route exact path={"/:lang" + regEx+"/asian/account/:ngcPage/:paymentChanelCode/:transactionId"} render={(props) => this.renderPage(props,'ngcPageContainer')}/>
						<Route exact path={"/:lang" + regEx+"/asian/balance"} render={(props) => this.renderPage(props,'balancePageContainer')}/>
						<Route exact path={"/:lang" + regEx+"/asian/promotions"} render={(props) => this.renderPage(props,'promotionsPageContainer')}/>
						<Route exact path={"/:lang" + regEx+"/asian/survey/:surveyId/:promotionId"} render={(props) => this.renderPage(props,'promotionSurveyContainer')}/>
						<Route exact path={"/:lang" + regEx+"/asian/settings"} render={(props) => this.renderPage(props,'settingsPageContainer')}/>
						<Route exact path={"/:lang" + regEx+"/asian/statements"} render={(props) => this.renderPage(props,'statementPageContainer')}/>
						<Route exact path={"/:lang" + regEx+"/asian/statements/:statement/:product/:date"} render={(props) => this.renderPage(props,'statementPageContainer')}/>
						<Route exact path={"/:lang" + regEx+"/asian/messages"} render={(props) => this.renderPage(props,'messagesPageContainer')}/>
						<Route exact path={"/:lang" + regEx+"/asian/announcements"} render={(props) => this.renderPage(props,'announcementsPageContainer')}/>
						<Route exact path={"/:lang" + regEx+"/asian/results"} render={(props) => this.renderPage(props,'resultsPageContainer')}/>
						<Route exact path={"/:lang" + regEx+"/asian/logout"} render={(props) => this.renderLogout(props,'homePageContainer')}/>
						<Route exact path={"/:lang" + regEx+"/asian/vs"} render={(props) => this.renderPage(props,'virtualSportsPageContainer')}/>
						<Route exact path={"/:lang" + regEx+"/asian/sports/"} render={(props) => this.renderPage(props,'oddsPageContainer')}/>
						<Route exact path={"/:lang" + regEx+"/asian/sports/:sportName"} render={(props) => this.renderPage(props,'oddsPageContainer')}/>
						<Route exact path={"/:lang" + regEx+"/asian/sports/outright/:sportName"} render={(props) => this.renderPage(props,'oddsPageContainer')}/>
            <Route exact path={"/:lang" + regEx+"/asian/sports/:sportName/:leagueName/:leagueId"} render={(props) => this.renderPage(props,'oddsPageContainer')}/>
						<Route exact path={"/:lang" + regEx+"/asian/sports/:sportName/:market/:betTypeGroup/:period"} render={(props) => this.renderPage(props,'oddsPageContainer')}/>
						<Route exact path={"/:lang" + regEx+"/asian/sports/:sportName/:code/:market/:betTypeGroup/:period"} render={(props) => this.renderPage(props,'oddsPageContainer')}/>
						<Route exact path={"/:lang" + regEx+"/asian/change-password"} render={(props) => this.renderPage(props,'changePasswordContainer')}/>
						<Route exact path={"/:lang" + regEx+"/asian/mfa"} render={(props) => this.renderPage(props,'multiFactorAuthenticationContainer')}/>
						<Route exact path={"/:lang" + regEx+"/asian/quick-stakes"} render={(props) => this.renderPage(props,'quickStakesContainer')}/>
						<Route exact path={"/:lang" + regEx + "/asian" + window.env.leaderBoardPathName} 
							render={(props) => window.env.enableLeaderboard
								? this.renderPage(props, "leaderboardPageContainer")
								: <Redirect to={`/${Utils.getCurrentLang()}/asian`}/> }/>

						<Route exact path={"/:lang" + regEx+"/asian/inplay/:sportName/:market/:betTypeGroup/:period"} render={(props) => this.renderPage(props,'oddsPageContainer')}/>
						<Route exact path={"/:lang" + regEx+"/asian/inplay/:sportName/:code/:market/:betTypeGroup/:period"} render={(props) => this.renderPage(props,'oddsPageContainer')}/>

						<Route exact path={"/:lang" + regEx+"/asian/esports/:code/:market/:betTypeGroup/:period"} render={(props) => this.renderPage(props,'oddsPageContainer')}/>
						<Route exact path={"/:lang" + regEx+"/asian/esports/:code/:leagueName/:leagueId"} render={(props) => this.renderPage(props,'oddsPageContainer')}/>
						<Route exact path={"/:lang" + regEx+"/asian/my-bets"} render={(props) => this.renderPage(props,'myBetsPageContainer')}/>
						<Route exact path={"/:lang" + regEx+"/asian/tc-page"} render={(props) => this.renderPage(props,'termsConditionsPageContainer')}/>		

						<Route exact path={"/:lang" + regEx+"/asian/casino/"} render={(props) => this.renderPage(props,'casinoPageContainer')}/>

						<Route exact path={"/:lang" + regEx+"/asian/live-casino/"} render={(props) => this.renderPage(props,'casinoPageContainer')}/>

						<Route exact path={"/:lang" + regEx+"/asian/prestige-club"} render={(props) => this.renderPage(props,'prestigeClubPageContainer')}/>

						<Route exact path={"/:lang" + regEx+"/Live"} render={(props) => this.renderPage(props,'liveGamesContainer')}/>
						<Route exact path={"/:lang" + regEx+"/Live/:sportName"} render={(props) => this.renderPage(props,'liveGamesContainer')}/>

						<Route exact path={"/:lang" + regEx+"/results"} render={(props) => this.renderPage(props,'resultPageContainer')}/>
						<Route exact path={"/:lang" + regEx + "/results/:date/sports"} render={(props) => this.renderPage(props,'resultSportsPageContainer')}/>	
						<Route exact path={"/:lang" + regEx + "/results/:date/:sp/:lg"} render={(props) => this.renderPage(props,'resultEventsPageContainer')}/>		
					
						<Route exact path={"/:lang" + regEx+"/graded-bets/:date(today|yesterday|7d|4w|custom)"} render={(props) => this.renderPage(props,'gradedBetPageContainer')}/>	
						<Route exact path={"/:lang" + regEx+"/bet-list/:date(\\d{4}-\\d{2}-\\d{2})"} render={(props) => this.renderPage(props,'gradedBetPageContainer')}/>	
					
						<Route exact path={"/:lang" + regEx+"/statement"} render={(props) => this.renderPage(props,'statementPageContainer')}/>
						<Route exact path={"/:lang" + regEx+"/statement/:date(7d|4w|1m|custom)"} render={(props) => this.renderPage(props,'statementPageContainer')}/>	
						
						<Route exact path={`/:lang${regEx}/messages`} render={(props) => this.renderPage(props,'messagesPageContainer')}/>
						<Route exact path={`/:lang${regEx}/announcements`} render={(props) => this.renderPage(props,'announcementsPageContainer')}/>

						<Route exact path={"/:lang" + regEx+"/:sportName"} render={(props) => this.renderPage(props,'homePageContainer')}/>
						<Route exact path={"/:lang" + regEx+"/:sportName/Live"} render={(props) => this.renderPage(props,'liveGamesContainer')}/>	
						<Route exact path={"/:lang" + regEx+"/:sportName/Today"} render={(props) => this.renderPage(props,'leaguesPageContainer')}/>	
						<Route exact path={"/:lang" + regEx+"/:sportName/Early"} render={(props) => this.renderPage(props,'leaguesPageContainer')}/>	
						<Route exact path={"/:lang" + regEx+"/:sportName/Specials"} render={(props) => this.renderPage(props,'leaguesPageContainer')}/>
						<Route exact path={"/:lang" + regEx+"/:sportName/Teasers"} render={(props) => this.renderPage(props,'leaguesPageContainer')}/>
						<Route exact path={"/:lang" + regEx+"/:sportName/markets"} render={(props) => this.renderPage(props,'leaguesPageContainer')}/>	
						<Route exact path={"/:lang" + regEx+"/:sportName/Today/:leagueName"} render={(props) => this.renderPage(props,'leaguesPageContainer')}/>	
						<Route exact path={"/:lang" + regEx+"/:sportName/Early/:leagueName"} render={(props) => this.renderPage(props,'leaguesPageContainer')}/>	
						<Route exact path={"/:lang" + regEx+"/:sportName/Specials/:leagueName"} render={(props) => this.renderPage(props,'leaguesPageContainer')}/>	
						<Route exact path={"/:lang" + regEx+"/:sportName/Teasers/:teaserTypeId/:teaserType/:teaserPoint"} render={(props) => this.renderPage(props,'oddsPageContainer')}/>	
						<Route exact path={"/:lang" + regEx+"/Live/:sportName/:leagueId/:leagueName/:eventId/:eventName"} render={(props) => this.renderPage(props,'oddsPageContainer')}/>	
						<Route exact path={"/:lang" + regEx+"/Live/:sportName/:leagueId/:leagueName"} render={(props) => this.renderPage(props,'oddsPageContainer')}/>	
						<Route exact path={"/:lang" + regEx+"/:sportName/:market/:leagueId/:leagueName/:eventId/:eventName"} render={(props) => this.renderPage(props,'oddsPageContainer')}/>	
						<Route exact path={"/:lang" + regEx+"/:sportName/:market/:leagueId/:leagueName"} render={(props) => this.renderPage(props,'oddsPageContainer')}/>
						<Route exact path={"/:lang" + regEx+"/asian/bet-builder"} render={(props) => this.renderPage(props,'betBuilderPageContainer')}/>	
						
						{/* <Route exact path={"/404"} component={() => {window.location.href = '/404'; return null;} }/>
						<Route path='*' component={() => { let url = window.location.href; if(!url.includes("/404")) {window.location.href = '/404';} return null;} }/>				 */}
					</Switch>
				</MbLayoutPage>
			</Switch>
			
		</React.Fragment>
		)		
	}

	renderPage = (props, pageContainer) => {
    //return <MbDynamicPage key = {pageContainer} {...props} pageContainer= {pageContainer}/>
		return <MbDynamicBody key = {pageContainer} {...props} pageContainer= {pageContainer}/>
	}

	render404Page = () => {
		window.location.href = '/404';
	}

	renderLogout = (props, pageContainer) => {

		AccountAction.logout().finally(function() { 
				AccountAction.clearDataOnBrowser();
					window.location = window.APP_ROUTER_BASE + '/' + Utils.getCurrentLang()
					+ '/' + Utils.getCurrentView();
			 });
		return <MbDynamicBody key = {pageContainer} {...props} pageContainer= {pageContainer}/>
	}

	requiredFormLogin = () => {
		const {templateData} = this.props.LayoutTemplateStore;
        const templateType = _.get(templateData, 'templateType', Constants.TEMPLATE_TYPE.WHITELABEL);
        if(templateType == Constants.TEMPLATE_TYPE.IFRAME) {
          AlertComponentAction.openAlert(i18next.t('REQUIRED_LOGIN'));
        } else {
          this.props.AccountStore.setRequiredFormData({
            isOpen: true
          })
        }
        return;
    }
}



// WEBPACK FOOTER //
// ./src/app/Routes.js